import { CREATE_RESUME_PAGE } from 'src/components/Router';
import { isSmallDevice } from 'src/modules/device';
import type { Page } from 'src/types';

export const READ = 'READ';
export const ADD = 'ADD';
export const EDIT = 'EDIT';

export const DELETE = 'DELETE';
export const REJECT = 'REJECT';

export const MODES = [READ, EDIT] as const;
export const ACTION_NAMES = [ADD, EDIT, DELETE] as const;

export type MODE = (typeof MODES)[number];

export const SIXTY_FPS = 1000 / 60;

export const NUM_FAILED_QUERIES_TO_TRIGGER_ERROR_PAGE = 3;

// Scroll options
const stickyHeaderHeightDesktop = 200;
const stickyHeaderHeightMobile = 81;
const scrollOffset = 32;

export const CREATE_RESUME_OFFSET_DESKTOP =
  stickyHeaderHeightDesktop + scrollOffset;
export const CREATE_RESUME_OFFSET_MOBILE =
  stickyHeaderHeightMobile + scrollOffset;

export const SCROLL_OPTIONS = {
  duration: 1500,
  offset: scrollOffset,
  delay: 10,
  minDuration: 300,
  speed: 1,
};

export const getScrollOptions = (page: Page) => {
  if (page === CREATE_RESUME_PAGE) {
    return {
      ...SCROLL_OPTIONS,
      offset: isSmallDevice()
        ? CREATE_RESUME_OFFSET_MOBILE
        : CREATE_RESUME_OFFSET_DESKTOP,
    };
  }

  return SCROLL_OPTIONS;
};
